import { ORDER_TYPE_ATONCE, PAYMENT_COMP } from '../../shop/constants';
import { isBetween } from '../../util/date';

export const isCurrentOnlyOrderType = orderType => orderType === ORDER_TYPE_ATONCE;

export const resolveAllotmentPeriodForCrd = (crd, currentAllotment, futureAllotment, orderType) => {
  if (
    crd &&
    currentAllotment &&
    isBetween({
      start: currentAllotment.contractStartDate,
      end: currentAllotment.contractEndDate,
      date: crd,
      inclusiveStart: true,
      inclusiveEnd: true
    })
  ) {
    return 'current';
  }

  if (
    !isCurrentOnlyOrderType(orderType) &&
    crd &&
    futureAllotment &&
    isBetween({
      start: futureAllotment.contractStartDate,
      end: futureAllotment.contractEndDate,
      date: crd,
      inclusiveStart: true,
      inclusiveEnd: true
    })
  ) {
    return 'future';
  }

  return 'none';
};

export const getCompSpendByContractPeriod = (products, currentAllotment, futureAllotment, orderType) =>
  products.reduce(
    (acc, product) => {
      if (product.paymentMethod !== PAYMENT_COMP) {
        return acc;
      }

      const period = resolveAllotmentPeriodForCrd(
        product.customerRequestDate,
        currentAllotment,
        futureAllotment,
        orderType
      );

      if (period === 'none') {
        return acc;
      }

      return {
        ...acc,
        [period]: acc[period] + (product.totals?.wholesale || 0)
      };
    },
    { current: 0, future: 0 }
  );

export const getCompAllotmentPeriods = (products, currentAllotment, futureAllotment, orderType) =>
  new Set(
    products
      .filter(product => product.paymentMethod === PAYMENT_COMP && product.customerRequestDate)
      .map(product =>
        resolveAllotmentPeriodForCrd(
          product.customerRequestDate,
          currentAllotment,
          futureAllotment,
          orderType
        )
      )
      .filter(period => period !== 'none')
  );

export const cartSpansMultipleContractPeriods = (products, currentAllotment, futureAllotment, orderType) =>
  getCompAllotmentPeriods(products, currentAllotment, futureAllotment, orderType).size > 1;

export const getProductsWithUnmappedAllotmentPeriod = (
  products,
  currentAllotment,
  futureAllotment,
  orderType
) =>
  products.filter(product => {
    if (product.paymentMethod !== PAYMENT_COMP || !product.customerRequestDate) {
      return false;
    }

    return (
      resolveAllotmentPeriodForCrd(
        product.customerRequestDate,
        currentAllotment,
        futureAllotment,
        orderType
      ) === 'none'
    );
  });

export const getCompAllotmentDisplay = ({
  products,
  currentAllotment,
  futureAllotment,
  currentDepartmentAllotment,
  futureDepartmentAllotment,
  orderType
}) => {
  const compSpendByPeriod = getCompSpendByContractPeriod(
    products,
    currentAllotment,
    futureAllotment,
    orderType
  );
  const periods = getCompAllotmentPeriods(products, currentAllotment, futureAllotment, orderType);
  const hasMixedPeriods = periods.size > 1;
  const singlePeriod = periods.size === 1 ? [...periods][0] : null;
  const periodDepartmentAllotments = {
    current: currentDepartmentAllotment,
    future: futureDepartmentAllotment
  };
  const singlePeriodDepartmentAllotment = singlePeriod
    ? periodDepartmentAllotments[singlePeriod]
    : null;

  return {
    compSpendByPeriod,
    hasMixedPeriods,
    singlePeriod,
    remainingAllotment: singlePeriodDepartmentAllotment?.remainingAllotment || 0,
    compSpend: singlePeriod ? compSpendByPeriod[singlePeriod] : 0,
    subTitleId:
      singlePeriod === 'future'
        ? 'cart.summary.multi.future.subTitle'
        : 'cart.summary.multi.comp.subTitle'
  };
};
